import { useAtom } from 'jotai';
import { drawerAtom } from '@/store/drawer-atom';
import { CloseIcon } from '@/components/icons/close-icon';
import { useRef } from 'react';
import { useCalcDivSize } from '@/lib/hooks/use-calc-div-size';
import { useDrawer } from './useDrawer';
import { searchDrawerAtom } from '@/store/searchDrawerAtom';

const DrawerWrapper = ({ children }: { children?: React.ReactNode }) => {
const [_, closeSidebar] = useAtom(drawerAtom);
  const menuHeaderRef = useRef(null);
  const { height } = useCalcDivSize(menuHeaderRef);
  const { closeDrawer } = useDrawer({
    atom: searchDrawerAtom,
  });

  return (
    <div className="flex h-full flex-col">
      <div
        ref={menuHeaderRef}
        className="fixed top-0 z-20 flex w-full max-w-md items-center justify-end bg-transparent p-4 px-4 md:px-6"
      >
        <button type="button"
          onClick={() => {
            closeDrawer();
            closeSidebar({ display: false, view: '' });
          }}
          className="flex items-center justify-center rounded-full bg-gray-200 text-body transition-all duration-200 hover:bg-accent hover:text-light focus:bg-accent focus:text-light focus:outline-0"
        >
          <span className="sr-only">{"fechar"}</span>
          <CloseIcon className="h-7 w-7" />
        </button>
      </div>
      <div style={{ paddingTop: height }}>{children}</div>
    </div>
  );
};

export default DrawerWrapper;
